import useStateStore from 'services/store';
import {
  BodyShape,
  Fit,
  InOrOut,
  NameSize,
  NiceWatch,
  ShirtCollar,
  ShoulderShape,
  Size,
} from '../InformationStep';

const BodyMeasurement = () => {
  const { inforStep } = useStateStore();

  return renderInfor(inforStep);
};

const renderInfor = (inforFlow: number) => {
  switch (inforFlow) {
    case 0:
      return <Size />;
    case 1:
      return <BodyShape />;
    case 2:
      return <ShoulderShape />;
    case 3:
      return <ShirtCollar />;
    case 4:
      return <InOrOut />;
    case 5:
      return <NiceWatch />;
    case 6:
      return <Fit />;
    case 7:
      return <NameSize />;
    default:
      return <Fit />;
  }
};

export default BodyMeasurement;
